import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SubtleBadge from "components/common/SubtleBadge";
import useFormattedDate from "hooks/useFormatDate";
import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

export const TagDetailsModal = ({
  selectedTag,
  loading,
  showModal,
  setShowModal,
}) => {
  const { formatDateTime } = useFormattedDate();

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      centered
      className="modal-small-text"
    >
      <Modal.Header className="py-3 fw-bold" style={{ fontSize: 14 }}>
        Tag Details
      </Modal.Header>
      <Modal.Body style={{ fontSize: "0.83rem" }}>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="success" />
          </div>
        ) : selectedTag ? (
          <div className="space-y-3">

            <div className="mb-3">
              <strong>Name:</strong> {selectedTag.name}
            </div>

            <div className="mb-3">
              <strong>Description:</strong>{" "}
              {selectedTag.description || "No description provided"}
            </div>
          </div>
        ) : (
          <p>Tag not found!</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          size="sm"
          variant="secondary"
          onClick={() => setShowModal(false)}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};